import { BILLING_WRITE } from 'pricing-pages-lib/constants/Scopes';
import { createSelector } from 'reselect';
import { APP } from '../constants/AuthType';
export const authSelector = state => state.auth;
export const isAppAuthSelector = state => {
  return !!(state.config && state.config.authType === APP);
};
export const isBillingAdminSelector = createSelector(authSelector, auth => {
  // This check is only for if we dual-deploy and have non-auth
  if (!auth || !auth.user || !auth.user.scopes) {
    return false;
  }
  const scopeList = auth.user.scopes;
  const hasHubBillingWrite = scopeList.some(scope => scope === BILLING_WRITE);
  return hasHubBillingWrite;
});